module.exports = __webpack_public_path__ + "static/media/logo-copernicus-small.a18efcc7.png";